import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'reducers';
import { AppBase } from '../App';
import styles from './Indroduction.module.scss';
import HsuLogo from '../../assets/HSU_Logo2.svg';
import DgkLogo from '../../assets/dgk_Logo.svg';
import DtecLogo from '../../assets/dtec_Logo.svg';
import FinancedLogo from '../../assets/financed_eu_Logo.svg';
import { Helmet } from 'react-helmet';
class Introduction extends AppBase {

  constructor(props) {
    super(props);
    this.unblock = null;
  }

  componentDidMount() {
    this.setState({ isShowToolbar: false });

    if (this.props.history && this.props.history.block) {
      this.unblock = this.props.history.block((location, action) => {
        // Fügen Sie hier Ihre Blockierungslogik hinzu
        return true;
      });
    }
  }

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }

  renderContent() {
    return (
      <div className={styles.introduction}>
        <Helmet>
          <title>Über die Plattform</title>
        </Helmet>
        <article>
          <h1>Über die Plattform</h1>
          <p>
            Diese Lernsoftware wird von der Professur für Betriebswirtschafts&shy;lehre, insbesondere <a href="https://www.hsu-hh.de/or/">Management Science und Operations Research, von Prof. Dr. Florian Jaehn</a>   zusammen mit der Professur für Betriebswirtschafts&shy;lehre, insbesondere <a href="https://www.hsu-hh.de/bp/">Beschaffung und Produktion, von Prof. Dr. Dominik Kreß</a>  der Helmut-Schmidt-Universität/Universität der Bundeswehr Hamburg (HSU) bereitgestellt. Die Software ist Teil des Projektes „Autonomes und hochflexibles IntraLogistik- Kompaktlager“ (<a href="https://dtecbw.de/home/forschung/hsu/projekt-aulokomp">AuLoKomp</a>), das durch das Zentrum für Digitalisierungs- und Technologieforschung der Bundeswehr (<a href="https://dtecbw.de/home">dtec.bw</a>) bewilligt wurde.
          </p>
          <p>
            Im Rahmen dieses Projektes werden für kompakte Lagersysteme Betriebsstrategien erforscht und entwickelt, um die Ein-, Aus- und Umlagerung von Kisten/Kleinladungsträger zu optimieren. Die Algorithmen, die zur Umsetzung des Optimierungskonzeptes des Lagersystems genutzt werden, finden ebenfalls in der Lehre Anwendung, um so den Studierenden der HSU den Transfer von Forschungsfragestellungen aus der Praxis in die Lehre zu vermitteln.
          </p>
          <p>
            In der Lernsoftware werden die Algorithmen des Projektes <a href="https://dtecbw.de/home/forschung/hsu/projekt-aulokomp">AuLoKomp</a> zusammengetragen. Die Integration in die Lehre findet entsprechend ihrer Inhalte in die Vorlesungen „Methoden des Operations Research“ und „Ablaufplanung“ der Professur Jaehn, sowie „Beschaffungs- und Bereitstellungsplanung“ und „Material-, Ersatzteillogistik und Lagerhaltung“ der Professur Kreß statt. Die Lernsoftware basiert hinsichtlich ihrer Umsetzungsidee auf der bereits vorhandenen Software <a href="https://www.wiwi.uni-siegen.de/mis/software/laves.html?lang=de">LAVES</a>.
          </p>
          <p>
            Die Lernsoftware ist sowohl für Anwender innerhalb der HSU als auch für Externe frei verfügbar.<br></br>
            Die Softwarearchitektur orientiert sich an der Plattform „<a href="https://algorithm-visualizer.org/">Algorithm Visualizer</a>“. Die Lernsoftware wurde im Zuge eines Ausschreibungsverfahrens von der <a href="https://www.digitalklang.de/">digitalklang creating solutions</a>  erstellt.
          </p>

          <h3>Copyright (c) 2019 Jinseo Jason Park</h3>
          <p>
            Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
            The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
          </p>
          <h2>Kooperation von</h2>
          <div className={styles.heroImages}>
            <a href='https://www.hsu-hh.de/'>
              <img className={styles.hsuLogo} src={HsuLogo} alt='HSU Logo Bild'></img>
            </a>
            <a href='https://dtecbw.de/home'>
              <img className={styles.dtecLogo} src={DtecLogo} alt='dtec.bw Logo Bild'></img>
            </a>
            <a href='https://next-generation-eu.europa.eu/index_de'>
              <img className={styles.financedLogo} src={FinancedLogo} alt='dtec.bw Logo Bild'></img>
            </a>
            <a href='https://www.digitalklang.de/'>
              <img className={styles.dgkLogo} src={DgkLogo} alt='digitalklang Logo Bild'></img>
            </a>
          </div>
        </article>
        <footer>
          <div>
            <div className={styles.footerLinks}>
              <a href="https://www.hsu-hh.de/impressum" target="_blank" rel="noreferrer">Impressum</a>
              <a href="https://www.hsu-hh.de/datenschutzerklaerung" target="_blank" rel="noreferrer">Datenschutzerklärung</a>
              <a href="https://www.hsu-hh.de/barrierefreiheitserklarung" target="_blank" rel="noreferrer">Barrierefreiheitserklärung</a>
              <a href="https://www.hsu-hh.de/" target="_blank" rel="noreferrer">HSU Website</a>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default connect(({ current, env }) => ({ current, env }), actions)(
  Introduction,
);
